import { AjaxRequest } from "../../utils/ajax-request.js";

// todo: move to separate file
function debounce(func, wait, immediate) {
	wait = wait || 300;

	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

export const InfinityScroll = {
	selectors: {
		infinityScrollButton: Array.prototype.slice.call(
			document.querySelectorAll(".js-infinity-scroll--button")
		),

		infinityScrollContent: Array.prototype.slice.call(
			document.querySelectorAll(".js-infinity-scroll--content")
		),
		infinityScrollContentLoader: ".js-comment-box__loading",

		infinityScrollSort: Array.prototype.slice.call(
			document.querySelectorAll(".js-infinity-scroll--sort")
		),
	},

	init: function () {
		const self = this;

		self.clickEvent(self.selectors.infinityScrollButton);
		self.scrollEvent(self.selectors.infinityScrollContent);
		self.sortEvent(self.selectors.infinityScrollSort);
	},

	clickEvent: function (_selector) {
		const self = this;

		if (!_selector) {
			return;
		}

		_selector.forEach(function (x) {
			const handleClick = debounce(function (e) {
				e.preventDefault();

				self.requestUrl(
					this.dataset.url,
					this.dataset.items,
					this.dataset.sort,
					this.dataset.append,
					this.dataset.version
				);
			});

			x.addEventListener("click", handleClick);
		});
	},

	scrollEvent: function (_selector) {
		const self = this;

		if (!_selector) {
			return;
		}

		_selector.forEach(function (element) {
			const handleScroll = debounce(function () {
				const currentPosition = element.scrollTop;
				const scrollHeight = element.scrollHeight;
				const clientHeight = element.clientHeight;

				const currentScroll = Math.round(currentPosition + clientHeight)

				if (currentScroll <= scrollHeight - 15) {
					return;
				}

				const targetElement = document.querySelector(
					"." + element.dataset.target
				);

				self.requestUrl(
					targetElement.dataset.url,
					targetElement.dataset.items,
					targetElement.dataset.sort,
					targetElement.dataset.append,
					targetElement.dataset.version
				);
			});

			element.addEventListener("scroll", handleScroll);
		});
	},

	sortEvent: function (_selector) {
		const self = this;

		if (!_selector) {
			return;
		}

		_selector.forEach(function (element) {
			const handleClick = debounce(function (e) {
				e.preventDefault();

				const targetElement = document.querySelector(
					"." + element.dataset.target
				);
				targetElement.dataset.sort = element.dataset.value;
				targetElement.removeAttribute("data-skip");

				self.requestUrl(
					targetElement.dataset.url,
					targetElement.dataset.items,
					targetElement.dataset.sort,
					targetElement.dataset.append,
					targetElement.dataset.version
				);
			});

			element.addEventListener("click", handleClick);
		});
	},

	requestUrl: function (_url, _items, _sort, _append, _version) {
		const self = this;
		const appendElement = document.querySelector("." + _append);
		const items = parseInt(_items);

		if (appendElement.dataset.remaining !== "0" || _sort) {
			appendElement.dataset.skip =
				appendElement.dataset.skip === undefined
					? 0
					: parseInt(appendElement.dataset.skip) + items;
			appendElement.classList.add("is-loading");

			const skip = appendElement.dataset.skip;

			let serviceURL = `${_url}?skip=${skip}&take=${items}`

			if (_version === '2025') {
				serviceURL += `&2025=true`;
			}

			if (_sort) {
				serviceURL += `&sort=${_sort}`;
			}

			AjaxRequest.create(serviceURL)
				.then((result) => {
					const resetAppendElement = !+skip; // always reset when loading 1st page
					self.updatePage(appendElement, result, resetAppendElement);

					const callback = new Function(
						appendElement.dataset.callback
					);
					if (typeof callback !== "undefined") {
						callback();
					}
				})
				.catch((err) => AjaxRequest.handleError(err))
				.finally(() => appendElement.classList.remove("is-loading"));
		}
	},

	updatePage: function (_element, _response, _resetElement) {
		const self = this;

		_element.dataset.remaining = _response.remaining;

		if (!_element) {
			return;
		}

		if (_resetElement) {
			const loader = _element
				.querySelector(self.selectors.infinityScrollContentLoader)
				.cloneNode(true);
			_element.innerHTML = "";
			_element.append(loader);
			_element.scrollTop = 0;
		}

		_element.innerHTML += _response.content;
	},
};

InfinityScroll.init();
